import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class MktEventListnerService {

  private _elementEvents = {}
  private _eventListnerSubject = new Subject<ListnerEvent>()

  eventListner$ = this._eventListnerSubject.asObservable()

  constructor() { }

  ngOnDestroy() {
    this._removeListners();
    this._elementEvents = {}
  }

  upsertElementEvent(elementEvent: ListnerEvent) {
    if (elementEvent.isDomListner) {
      const key = elementEvent.id
      const isExist = Object.keys(this._elementEvents).find(e => e === key);
      if (!isExist) {
        this._elementEvents[key] = elementEvent;
        this._addListner(this._elementEvents[key]);
      }
    }
  }

  triggerListner(listner: ListnerEvent) {
    this._eventListnerSubject.next(listner);
  }

  // addListners() {
  //   const eventList = this._getElementList(this._elementEvents)
  //   this._addEventToElements(eventList)
  // }

  private _removeListners() {
    const eventList = this._getElementList(this._elementEvents)
    this._removeEventFromElements(eventList)
  }

  private _getElementList(eventObj = {}) {
    const array: Array<ListnerEvent> = []
    Object.keys(eventObj).forEach(k => {
      array.push(eventObj[k])
    })
    return array;
  }

  // /**
  //  * 
  //  * add listners to elements passed in an array of object
  //  */
  // private _addEventToElements(events: ListnerElement[]) {
  //   events.forEach(e => {
  //     this._addListner(e)
  //   })
  // }

  /**
   * 
   * remove existing listners to elements passed in an array of object which are added in above method
   */
  private _removeEventFromElements(events: ListnerEvent[]) {
    events.forEach(e => {
      this._removeListner(e)
    })
  }

  /**
   * 
   * add event listner,
   */
  private _addEvent(domElement: HTMLElement, event: ListnerEvent) {
    const listnerElement: ListnerEvent = { ...event, domElement }
    this._elementEvents[event.id] = listnerElement
    if (event.isDomListner && event.domEventType === 'click') {
      domElement.addEventListener(event.domEventType, this._clickEventListner.bind(this, [listnerElement]))
    }
  }

  /**
   * 
   * remove event listner which is added in above method in this method,
   */
  private _removeEvent(domElement: HTMLElement, event: ListnerEvent) {
    const listnerElement: ListnerEvent = { ...event, domElement }
    this._elementEvents[event.id] = listnerElement
    if (event.isDomListner && event.domEventType === 'click') {
      domElement.removeEventListener(event.domEventType, this._clickEventListner)
    }
  }

  private _addListner(e: ListnerEvent) {
    if (e.isDomListner) {
      const element = document.querySelector(`[data-id="${e.domElementId}"]`)|| document.getElementById(e.domElementId);
      if (element) {
        this._addEvent(element as HTMLElement, e)
      }
    }
  }

  private _removeListner(e: ListnerEvent) {
    if (e.isDomListner) {
      const domElement = document.getElementById(e.domElementId);
      if (domElement) {
        this._removeEvent(domElement, e)
      }
    } 
  }

  private _clickEventListner = (args) => {
    this.triggerListner(args[0]);
  }

}

export interface ListnerEvent {
  id: string
  isDomListner?: boolean
  domElementId?: string 
  domEventType?: string
  domElement?: HTMLElement
}
